// Modules
// import { Button } from '@dasa-health/components-react'
import { BottomSheet } from 'components'
import React, { ReactNode, useEffect } from 'react'
import { useTracking } from 'react-tracking'
import { Icon } from '@dasa-health/alma-react'
import { CustomModalError } from 'redesign/components/atoms/CustomModalError'
import { Close, Whatsapp } from '@dasa-health/alma-icons'

// Application
import { getOrigin, userDeviceDetect } from 'utils'

// Components
import {
    BottomSheetContent,
    BottomSheetTitle,
    BottomSheetWrapper,
    BottomSheetButtonWrapper,
    BottomSheetTitleContainer,
    CustomButton,
} from './styles'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'

export interface SignUpModalProps {
    showModal: boolean
    setShowModal: (isOpen: boolean) => void
    title?: string
    children?: ReactNode
}

export const SignUpModalError = ({ showModal, setShowModal, title, children }: SignUpModalProps) => {
    const { trackEvent } = useTracking()
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    const { isPortable } = userDeviceDetect()

    const buttonData = {
        href: 'https://api.whatsapp.com/send/?phone=551140202117',
        icon: <Whatsapp />,
        taget: '_blank',
    }

    useEffect(() => {
        showModal &&
            trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: getOrigin(biometyDataLS?.origin!),
                    current_step: biometyDataLS?.contacts ? 'Modal - erro com contato no mdm' : 'Modal - erro sem contato no mdm',
                },
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    function handleClose() {
        return setShowModal(false)
    }

    return (
        <>
            {showModal && !isPortable && (
                <CustomModalError buttonData={buttonData} onClose={handleClose} open={showModal} title={title}>
                    {children}
                </CustomModalError>
            )}
            {showModal && isPortable && (
                <BottomSheet isOpen={showModal} onRequestClose={handleClose}>
                    <BottomSheetWrapper>
                        <BottomSheetTitleContainer>
                            {title && <BottomSheetTitle>{title}</BottomSheetTitle>}{' '}
                            <button data-testid="close-button" onClick={() => setShowModal(false)} type="button">
                                <Icon size="lg">
                                    <Close />
                                </Icon>
                            </button>
                        </BottomSheetTitleContainer>
                        {children && <BottomSheetContent>{children}</BottomSheetContent>}
                        <BottomSheetButtonWrapper>
                            <CustomButton
                                data-current-service="Reconhecimento Facial"
                                data-item-position="Modal Falha no reconhecimento facial"
                                data-item-text="Falar com atendente"
                                href={buttonData.href}
                                target={buttonData.taget}
                                title="Falar com atendente"
                                type="button"
                            >
                                {buttonData.icon && <Icon size="lg">{buttonData.icon}</Icon>}
                                Falar com atendente
                            </CustomButton>
                        </BottomSheetButtonWrapper>
                    </BottomSheetWrapper>
                </BottomSheet>
            )}
        </>
    )
}
